<template>
  <SimpleModal
    title="common.import"
    size="middle"
    destroyOnClose
    :footer="null"
    :closeFunc="async () => !loading"
    @register="registerModal"
  >
    <div class="p-16px pt-6px flex items-center">
      <MUpload uploadType="excel" @upload-success="uploadSuccess" />
      <SyncExportBtn
        v-if="props.template && Object.keys(props.template).length"
        type="link"
        :path="props.template.path || '/low-code/lowCode/universal/file/template/download'"
        :params="getTemplateParams"
      >
        {{ t('c.25090337') }}
      </SyncExportBtn>
      <span class="ml-2 text-[#bdbdbd]">
        {{ t('c.25090336') + ACCEPT_EXTS.split(',').join(' ') }}
      </span>
    </div>

    <AsyncRecordTable
      v-if="typeCode"
      ref="tableRef"
      class="!h-unset"
      :typeCode="[typeCode]"
      :bizKey="bizKey"
    />
  </SimpleModal>
</template>

<script setup lang="ts">
  import { computed, ref } from 'vue';
  import { message } from '@mts-fe/utils';
  import { SyncExportBtn } from '@mts/components/Export';
  import { SimpleModal, useModalInner } from '@mts/components/Modal';
  import { t } from '@mts/hooks/web/useI18n';
  import { createApi } from '@mts/render/api';
  import { AsyncRecordTable } from '@mts/render/components/OperationLogs';
  import { MUpload } from '@mts/render/components/Upload';
  import type { ImportProps } from '..';

  const ACCEPT_EXTS = '.xls,.xlsx';
  const props = withDefaults(defineProps<ImportProps>(), {
    template: () => ({}),
  });
  const typeCode = computed(() => {
    return props.template?.templateCode || props.template?.templateKey;
  });

  const emit = defineEmits(['register', 'ok']);
  const getTemplateParams = () => {
    const { params, ...rest } = props.template;
    const _params = typeof params === 'function' ? params() : params;
    return { ...rest, ..._params };
  };

  const bizKey = computed(() => {
    return getTemplateParams().bizKey;
  });

  const [registerModal] = useModalInner();

  const getParams = () => (typeof props.params == 'function' ? props.params() : props.params) || {};

  const tableRef = ref();
  const loading = ref(false);
  function uploadSuccess({ fileUrl }) {
    if (!props.action) return console.warn('请配置导入接口', props);

    loading.value = true;
    createApi(props.action)({ ...getParams(), fileUrl, realUpload: true })
      .then((res) => {
        message.success(t('g.25120002'));
        tableRef.value?.reload();
        emit('ok', res);
      })
      .finally(() => (loading.value = false));
  }
</script>
